import { render, staticRenderFns } from "./FormDepartmentComponent.vue?vue&type=template&id=47f455da&scoped=true"
import script from "./FormDepartmentComponent.vue?vue&type=script&lang=js"
export * from "./FormDepartmentComponent.vue?vue&type=script&lang=js"
import style0 from "./FormDepartmentComponent.vue?vue&type=style&index=0&id=47f455da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f455da",
  null
  
)

export default component.exports